export enum ELoginStatus {
    LOGIN,
    LOGOUT,
}